<template>
  <table :id="name" :class="tableClass">
  </table>
</template>

<script>
import Vue from 'vue';
import UpliftRating from './UpliftRating';
import dc from 'dc';
import utils from '@/modules/utils';

let crossfilter = dc.crossfilter;

  const UpliftRatingCtor = Vue.extend(UpliftRating);

  /* eslint-disable */
  export default {
    name: 'dc-data-table',
    props: ['csv', 'name', 'columns', 'tableClass', 'sortFunction',
            'dimensionFunction', 'textDimensionFunction', 'maxFunction',
            'filterFunction', 'wrapMaxColumn'],
    components: {
      UpliftRating
    },
    data: function() {
      return {
        maxValue: null,
        dataTable: null,
        dimensionData: null,
        textDimension: null,
        csvData: null,
        allCsv: null
      };
    },
    mounted: function() {
      this.$nextTick(function () {
        this.setupDataTable();
      });
    },
    computed: {},
    methods: {
      filter: function(f) {
        var self = this;
        if (f !== undefined) {
          self.dimensionData.filterAll();
          var filteredUplift = self.dimensionData.filter(f);
        }
        dc.renderAll(self.name);
      },
      filterText: function(text) {
        if (this.textDimension == null) {
          return;
        }
        var filteredTest = this.textDimension.filter(utils.filter.filterText(text));
        dc.renderAll(this.name);
      },
      setupDataTable: function() {
        var self = this;
        var dataTable = dc.dataTable("#"+self.name, self.name);
        this.dataTable = dataTable;

        self.$dataStore.csv(this.csv, function(csv) {
          self.allCsv = csv;
          self.csvData = crossfilter(self.allCsv);
          var dimensionData = self.csvData.dimension(self.dimensionFunction);
          if (self.textDimensionFunction !== undefined) {
            self.textDimension = self.csvData.dimension(self.textDimensionFunction);
          }
          self.dimensionData = dimensionData;
          if (self.filterFunction !== undefined) {
            dimensionData.filterAll();
            var filteredUplift = dimensionData.filter(self.filterFunction);
          }

          if (self.maxFunction !== undefined) {
            var maxDimension = self.csvData.dimension(self.maxFunction);
            var reducedMax = maxDimension.group().reduceSum(self.maxFunction);
            self.maxValue = reducedMax.top(reducedMax.size())[0].value;

            if (self.wrapMaxColumn !== undefined && self.maxValue !== null) {
              for (var idx in self.columns) {
                var column = self.columns[idx];
                if (column.label === self.wrapMaxColumn) {
                  var formatter = column.format;
                  column.format = function (d) {
                    var val = formatter(d);
                    var widget = new UpliftRatingCtor({propsData: {max: self.maxValue, value: val}}).$mount()
                    return widget.$el.innerHTML;
                  };
                  break;
                }
              }
            }
          }

          dataTable
            .dimension(dimensionData)
            .group(function(d) { return false; })
            .order(d3.descending)
            .sortBy(self.sortFunction)
            .size(Infinity)
            .showGroups(false)
            .columns(self.columns)
            .beginSlice(0)
            .endSlice(100);
          dc.renderAll(self.name);
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/DcDataTable.vue